module.exports = __webpack_public_path__ + "img/check.0e38d3e6.svg";